import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcesses(agro_exporter_id) {
    return RequesterV1.get(
      `agro_exporter/reporting/process/list_processes/${agro_exporter_id}`
    );
  },
  fetchReport(agro_exporter_id) {
    return RequesterV1.get(
      `agro_exporter/reporting/process/list_processes/report/${agro_exporter_id}`
    );
  }
};
